import { StateSubject } from './state-subject';
import { Session } from '../interfaces/session.model';

export class SessionState extends StateSubject<Session>
{
  constructor()
  {
    super({
      jwt: '',
      fleet: null,
      driverStatus: 0,
      verificationRequirement: 0,
      taxiNo: null,
      trackingID: null,
      hasGoingHomeTime: false,
      driverName: null,
      appStartTimeStamp: null,
      canDeleteDriver: false
    });
  }
}
